<template>
    <div class="table-layout mt10">
        <el-table ref="staffQualiTypeTable" :data="staffQualiList" border tooltip-effect="dark" style="width: 100%">
            <el-table-column prop="innerTypeName" label="资质类型名称" align="left" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="级别" align="center" width="60">
                <template slot-scope="rows">
                    <span v-if="rows.row.level == 1">一级</span>
                    <span v-if="rows.row.level == 2">二级</span>
                    <span v-if="rows.row.level == 3">三级</span>
                    <span v-if="rows.row.level == 4">四级</span>
                    <span v-if="rows.row.level == 5">五级</span>
                </template>
            </el-table-column>
            <el-table-column prop="innerLevelName" label="级别名称" align="left" width="160" show-overflow-tooltip></el-table-column>
            <!--<el-table-column prop="certNo" label="证书编号" align="center" width="150"></el-table-column>
            <el-table-column prop="registNo" label="登记编号" align="center" width="150"></el-table-column>-->
            <el-table-column prop="obtainDate" label="有效起始日" align="center" width="100"></el-table-column>
            <el-table-column prop="expireDate" label="失效日期" align="center" width="100">
                <template slot-scope="rows">
                    <span v-if="rows.row.longTermFlag" class="font-green">长期有效</span>
                    <span v-else>{{rows.row.expireDate || '无'}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="levelName" label="附件" align="left">
                <template slot-scope="rows">
                    <div class="file-area clearfix small-picture">
                        <div class="mr15 inline-block" v-for="(file, index) in rows.row.fileList">
                            <div class="file-item show-usage image viewable downloadable" :title="file.fileName">
                                <div class="file-content" :title="file.fileName">
                                    <img :src="file.fileBrowseUrl"/>
                                    <div class="operation-group">
                                        <i class="icon iconfont icon-chakan view" @click="viewImage(file.fileBrowseUrl)"></i>
                                        <i class="icon iconfont icon-xiazai download" @click="downloadFile(file.fileUuid);"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <!--<el-table-column label="认证状态" align="center" width="70">
                <template slot-scope="rows">
                    <span v-if="rows.row.verifyFlag == 0" class="font-red">未认证</span>
                    <span v-if="rows.row.verifyFlag == 1" class="font-green">认证有效</span>
                    <span v-if="rows.row.verifyFlag == -1" class="font-red">认证无效</span>
                </template>
            </el-table-column>
            <el-table-column prop="checkFlag" label="核对状态" align="center" width="70">
                <template slot-scope="rows">
                    <span v-if="rows.row.verifyFlag == 0" class="font-red">未核对</span>
                    <span v-if="rows.row.verifyFlag == 1" class="font-green">核对有效</span>
                    <span v-if="rows.row.verifyFlag == -1" class="font-red">核对无效</span>
                </template>
            </el-table-column>-->
            <!--<el-table-column prop="checkerName" label="核对人" align="left" width="130"></el-table-column>-->
            <!--<el-table-column prop="memo" label="备注" align="center" show-overflow-tooltip></el-table-column>-->
            <!--<el-table-column prop="createTime" label="创建时间" align="center" width="160"></el-table-column>-->
        </el-table>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import { openBigImgDlg } from '../comn/dialog'

    import merchtQualiApi from '../../api/merchtQuali'

    export default {
        name: 'swb-staff-quali-show',
        desc: '人员资质类型-选择',
        props: {
            merchantType: {},
            filter: {
                type: Object,
                default: {}
            },
        },
        data: function () {
            return {
                staffQualiList: [],
            }
        },
        created: function () {
            //
            this.getStaffQualiTypeList();
        },
        methods: {
            getStaffQualiTypeList: function () {
                let self = this;
                let postData = this.filter;
                postData.merchantType = this.merchantType;
                let theLoad = MsgBox.loading();
                merchtQualiApi.getStaffQualiByFilter(postData, function (result) {
                    theLoad.close();
                    if(result.type === "info") {
                        //
                        self.staffQualiList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            viewImage: function (fileBrowseUrl) {
                openBigImgDlg(fileBrowseUrl);
            },
            downloadFile: function (fileUuid) {
                Utils.downloadFile(getAppUrl("/file/download?uuid=" + fileUuid));
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/quali/StaffQualiForShow.vue